export default __webpack_public_path__ + "static/media/designation-check.dc843556.svg";